import {useFormContext} from "react-hook-form";
import {FormValues} from "./schema";

export const usePermittedHours = (variantIndex: number) => {
  const {watch} = useFormContext<FormValues>();
  const permittedHours = watch(`variants.${variantIndex}.policy.permitted_hours`);
  const isNotPermitted = (hour: number) => !permittedHours.includes(hour);
  return {isNotPermitted};
};
